import {AnalyticsFilterItem} from '../../filters/common/helpers';
import {useAnalyticsAccountsFilter} from '../../filters/useAnalyticsAccountsFilter';
import {useAnalyticsChannelsFilter} from '../../filters/useAnalyticsChannelsFilter';
import {useAnalyticsExcludeTagsFilter} from '../../filters/useAnalyticsExcludeTagsFilter';
import {useAnalyticsTagsFilter} from '../../filters/useAnalyticsTagsFilter';

/*
 * Hook.
 */

export const useExtraFilters = () => {
  // The order of the filters in this array is the order they will appear in the filter bar
  const extraFilters: Array<AnalyticsFilterItem> = [
    useAnalyticsChannelsFilter(),
    useAnalyticsAccountsFilter(),
    useAnalyticsTagsFilter(),
    useAnalyticsExcludeTagsFilter(),
  ];

  const activeExtraFilters = extraFilters.filter((filter) => filter.isActive);
  const inactiveExtraFilters = extraFilters.filter((filter) => !filter.isActive);

  return {activeExtraFilters, inactiveExtraFilters};
};
